module.exports = __webpack_public_path__ + "files/357d675366cce0fbb6ca5e1474ae489c.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300.eot
// module id = 450
// module chunks = 76